import React, { useState } from 'react';
import axios from 'axios';

import UserScoresList from './UserScoresList'

const ActivityScoreCalculator = ({
}) => {
  const [userIds, setUserIds] = useState([])
  const [userScores, setUserScores] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = (e) => {
    e.preventDefault()
    setIsLoading(true)

    axios.get(`/${gon.currentProvider}/api/activity_scores/calculate`, {
      params: {
        user_ids: userIds
      }
    })
      .then((res) => {
        if (res.status == 200) {
          setUserScores(res.data)
          setIsLoading(false)
        }
      })
  }

  return (
    <React.Fragment>
      <div className='Main__Wrapper'>
        <div className='MainHeader'>
          <div className='MainHeader__left'>
            <h2 className='MainHeader__h2'>Score Calculator</h2>
          </div>
        </div>
        <div className='Container'>
          <div className='Container__row' style={{ gridTemplateColumns: '1fr 2fr' }}>
            <div className='Container__col'>
              <form onSubmit={onSubmit}>
                <div className='Container__form'>
                  <label className='User__form__label'>User IDs</label>

                  <textarea
                    className='Input'
                    rows={10}
                    placeholder='13353&#10;212121&#10;123145'
                    onChange={(e) => {
                      setUserIds(e.target.value)
                    }}
                  />

                  <button
                    className='Button Button--blue'
                    disabled={isLoading}
                    onClick={onSubmit}
                  >
                    {isLoading ? 'Loading …' : 'Calculate'}
                  </button>
                </div>
              </form>
            </div>
            <div className='Container__col'>
              <UserScoresList userScores={userScores} />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ActivityScoreCalculator;
